/** Existing translate-cli messages moved into the owning module. */
export const nyroMessages: Record<
  string,
  { open: string; verify: string; unavailable: string; verified: string }
> = {
  ar: {
    open: 'الانتقال إلى Nyro',
    verify: 'تحقق من بريدك الإلكتروني للمتابعة',
    unavailable: 'تسجيل الدخول إلى Nyro غير متاح الآن. حاول لاحقًا.',
    verified: 'تم التحقق من بريدك الإلكتروني. يمكنك الآن الانتقال إلى Nyro.',
  },
  az: {
    open: 'Nyro-ya keç',
    verify: 'Davam etmək üçün e-poçtunuzu təsdiqləyin',
    unavailable:
      'Nyro-ya giriş hazırda mümkün deyil. Daha sonra yenidən cəhd edin.',
    verified: 'E-poçtunuz təsdiqləndi. İndi Nyro-ya keçə bilərsiniz.',
  },
  bn: {
    open: 'Nyro-তে যান',
    verify: 'চালিয়ে যেতে আপনার ইমেইল যাচাই করুন',
    unavailable:
      'এই মুহূর্তে Nyro-তে সাইন ইন করা যাচ্ছে না। পরে আবার চেষ্টা করুন।',
    verified: 'আপনার ইমেইল যাচাই হয়েছে। এখন Nyro-তে যেতে পারেন।',
  },
  cn: {
    open: '前往 Nyro',
    verify: '请验证邮箱以继续',
    unavailable: '暂时无法登录 Nyro，请稍后重试。',
    verified: '邮箱已验证，现在可以前往 Nyro。',
  },
  cz: {
    open: 'Přejít do Nyro',
    verify: 'Pro pokračování ověřte svůj e-mail',
    unavailable: 'Přihlášení do Nyro nyní není dostupné. Zkuste to později.',
    verified: 'E-mail je ověřen. Nyní můžete přejít do Nyro.',
  },
  de: {
    open: 'Nyro öffnen',
    verify: 'Bestätige deine E-Mail-Adresse, um fortzufahren',
    unavailable:
      'Die Anmeldung bei Nyro ist derzeit nicht möglich. Versuche es später erneut.',
    verified:
      'Deine E-Mail-Adresse ist bestätigt. Du kannst jetzt Nyro öffnen.',
  },
  en: {
    open: 'Open Nyro',
    verify: 'Verify your email to continue',
    unavailable:
      'Sign-in to Nyro is unavailable right now. Please try again later.',
    verified: 'Your email is verified. You can now open Nyro.',
  },
  es: {
    open: 'Ir a Nyro',
    verify: 'Verifica tu correo electrónico para continuar',
    unavailable:
      'No se puede iniciar sesión en Nyro en este momento. Inténtalo más tarde.',
    verified: 'Tu correo está verificado. Ya puedes ir a Nyro.',
  },
  fr: {
    open: 'Ouvrir Nyro',
    verify: 'Vérifiez votre adresse e-mail pour continuer',
    unavailable:
      'La connexion à Nyro est indisponible pour le moment. Réessayez plus tard.',
    verified:
      'Votre adresse e-mail est vérifiée. Vous pouvez maintenant ouvrir Nyro.',
  },
  hi: {
    open: 'Nyro खोलें',
    verify: 'आगे बढ़ने के लिए अपना ईमेल सत्यापित करें',
    unavailable:
      'अभी Nyro में साइन इन नहीं हो पा रहा है। बाद में फिर कोशिश करें।',
    verified: 'आपका ईमेल सत्यापित हो गया है। अब आप Nyro खोल सकते हैं।',
  },
  id: {
    open: 'Buka Nyro',
    verify: 'Verifikasi email Anda untuk melanjutkan',
    unavailable: 'Login ke Nyro sedang tidak tersedia. Coba lagi nanti.',
    verified:
      'Email Anda telah diverifikasi. Sekarang Anda dapat membuka Nyro.',
  },
  it: {
    open: 'Apri Nyro',
    verify: 'Verifica la tua email per continuare',
    unavailable:
      'Al momento non è possibile accedere a Nyro. Riprova più tardi.',
    verified: 'La tua email è verificata. Ora puoi aprire Nyro.',
  },
  iw: {
    open: 'פתיחת Nyro',
    verify: 'יש לאמת את כתובת האימייל כדי להמשיך',
    unavailable: 'הכניסה ל-Nyro אינה זמינה כרגע. נסו שוב מאוחר יותר.',
    verified: 'כתובת האימייל אומתה. אפשר כעת לפתוח את Nyro.',
  },
  ja: {
    open: 'Nyroを開く',
    verify: '続行するにはメールアドレスを認証してください',
    unavailable:
      '現在Nyroにログインできません。しばらくしてからもう一度お試しください。',
    verified: 'メールアドレスが認証されました。Nyroを開けます。',
  },
  ka: {
    open: 'Nyro-ზე გადასვლა',
    verify: 'გასაგრძელებლად დაადასტურეთ ელფოსტა',
    unavailable: 'Nyro-ში შესვლა ამჟამად მიუწვდომელია. სცადეთ მოგვიანებით.',
    verified: 'ელფოსტა დადასტურებულია. ახლა შეგიძლიათ Nyro-ზე გადასვლა.',
  },
  kk: {
    open: 'Nyro-ға өту',
    verify: 'Жалғастыру үшін электрондық поштаңызды растаңыз',
    unavailable: 'Қазір Nyro-ға кіру мүмкін емес. Кейінірек қайталап көріңіз.',
    verified: 'Электрондық пошта расталды. Енді Nyro-ға өте аласыз.',
  },
  ko: {
    open: 'Nyro 열기',
    verify: '계속하려면 이메일을 인증해 주세요',
    unavailable: '현재 Nyro에 로그인할 수 없습니다. 나중에 다시 시도해 주세요.',
    verified: '이메일이 인증되었습니다. 이제 Nyro를 열 수 있습니다.',
  },
  ky: {
    open: 'Nyro-го өтүү',
    verify: 'Улантуу үчүн электрондук почтаңызды ырастаңыз',
    unavailable:
      'Азыр Nyro-го кирүү мүмкүн эмес. Кийинчерээк кайра аракет кылыңыз.',
    verified: 'Электрондук почта ырасталды. Эми Nyro-го өтө аласыз.',
  },
  pl: {
    open: 'Otwórz Nyro',
    verify: 'Potwierdź swój adres e-mail, aby kontynuować',
    unavailable:
      'Logowanie do Nyro jest teraz niedostępne. Spróbuj ponownie później.',
    verified: 'Adres e-mail został potwierdzony. Możesz teraz otworzyć Nyro.',
  },
  pt: {
    open: 'Abrir Nyro',
    verify: 'Verifique seu e-mail para continuar',
    unavailable:
      'Não é possível entrar no Nyro agora. Tente novamente mais tarde.',
    verified: 'Seu e-mail foi verificado. Agora você pode abrir o Nyro.',
  },
  ro: {
    open: 'Deschide Nyro',
    verify: 'Confirmă adresa de e-mail pentru a continua',
    unavailable:
      'Autentificarea în Nyro nu este disponibilă acum. Încearcă mai târziu.',
    verified: 'Adresa de e-mail a fost confirmată. Acum poți deschide Nyro.',
  },
  ru: {
    open: 'Перейти в Nyro',
    verify: 'Верифицируйте почту, чтобы продолжить',
    unavailable: 'Вход в Nyro сейчас недоступен. Попробуйте позже.',
    verified: 'Почта подтверждена. Теперь можно перейти в Nyro.',
  },
  sw: {
    open: 'Fungua Nyro',
    verify: 'Thibitisha barua pepe yako ili kuendelea',
    unavailable:
      'Kuingia kwenye Nyro hakupatikani kwa sasa. Jaribu tena baadaye.',
    verified: 'Barua pepe yako imethibitishwa. Sasa unaweza kufungua Nyro.',
  },
  tr: {
    open: 'Nyro’yu aç',
    verify: 'Devam etmek için e-postanızı doğrulayın',
    unavailable:
      'Şu anda Nyro’ya giriş yapılamıyor. Daha sonra tekrar deneyin.',
    verified: 'E-postanız doğrulandı. Artık Nyro’yu açabilirsiniz.',
  },
  ua: {
    open: 'Перейти до Nyro',
    verify: 'Підтвердьте пошту, щоб продовжити',
    unavailable: 'Вхід до Nyro зараз недоступний. Спробуйте пізніше.',
    verified: 'Пошту підтверджено. Тепер можна перейти до Nyro.',
  },
  uz: {
    open: 'Nyro’ga o‘tish',
    verify: 'Davom etish uchun emailingizni tasdiqlang',
    unavailable:
      'Hozir Nyro’ga kirib bo‘lmaydi. Keyinroq qayta urinib ko‘ring.',
    verified: 'Emailingiz tasdiqlandi. Endi Nyro’ga o‘tishingiz mumkin.',
  },
  vi: {
    open: 'Mở Nyro',
    verify: 'Xác minh email của bạn để tiếp tục',
    unavailable: 'Hiện chưa thể đăng nhập Nyro. Vui lòng thử lại sau.',
    verified: 'Email đã được xác minh. Bây giờ bạn có thể mở Nyro.',
  },
  zh: {
    open: '前往 Nyro',
    verify: '请验证邮箱以继续',
    unavailable: '暂时无法登录 Nyro，请稍后重试。',
    verified: '邮箱已验证，现在可以前往 Nyro。',
  },
}
